import { ownsUrl } from '@/js/core/utils/modal-route';

let pendingPath = null;

/**
 * Show the current page from the top when a modal opened from it closes.
 *
 * Closing restores the origin page at whatever offset it was left at, dropping the
 * visitor part-way down wherever they clicked.
 */
export function scrollToTopOnReturn() {
  pendingPath = window.location.pathname;
}

/**
 * Apply a pending return as a navigation lands. Called from the router's afterEach.
 *
 * Firing here rather than at close time covers leaving the modal by browser Back as
 * well as by the close control.
 */
export function applyPendingReturnScroll(to) {
  if (!pendingPath) return;

  if (to.path !== pendingPath) {
    // Still on the modal that was opened; only a move to some other page abandons it.
    if (ownsUrl(to)) pendingPath = null;

    return;
  }

  pendingPath = null;

  // The origin page re-renders on this navigation.
  requestAnimationFrame(() => window.scrollTo({ top: 0 }));
}
